export const SPECIALITY_BOOKING_TYPES = ['Speciality', 'Second Opinion'];
